<template>
    <i v-if="loading" class="fa fa-spinner fa-spin"></i>
</template>

<script>
    // Font awesome loading spinner icon
    export default {
        name: "LoadingIcon",
        props: {
            // Animate icon
            loading: {
                type: Boolean,
                required: true,
                default: false,
            }
        },
    }
</script>

<style scoped>
    i {
        margin: auto 6px;
        font-size: 1em;
    }
</style>
